import * as zod from 'zod/mini'

const nonEmptyStringSchema = zod.string().check(zod.minLength(1))
const nullableNonEmptyStringSchema = zod.nullable(nonEmptyStringSchema)

const udpTrackingPriceSchema = zod.object({
  amount: zod.number(),
  discount: zod.number(),
  strike_price: zod.optional(zod.number()),
})

const udpTrackingSellerSchema = zod.object({
  id: zod.string(),
})

const udpTrackingProductSchema = zod.object({
  is_marketplace: zod.boolean(),
  is_now_product: zod.optional(zod.boolean()),
  is_own_brand: zod.optional(zod.boolean()),
  is_sponsored: zod.optional(zod.boolean()),
  price: udpTrackingPriceSchema,
  rating: zod.optional(zod.number()),
  seller: zod.optional(udpTrackingSellerSchema),
  status: zod.optional(zod.string()),
  upid: nonEmptyStringSchema,
})

const recommendationOriginDataSchema = zod.object({
  position: zod.number(),
  recommendation_id: nonEmptyStringSchema,
  tracking_token: nullableNonEmptyStringSchema,
  widget_id: nonEmptyStringSchema,
})

const searchHeaderOriginDataSchema = zod.object({
  organic_position: zod.number(),
  position: zod.number(),
  query_id: nullableNonEmptyStringSchema,
})

const searchPageOriginDataSchema = zod.object({
  organic_position: zod.number(),
  position: zod.number(),
  query_id: nonEmptyStringSchema,
})

const cartAdditionSchema = zod.object({
  added_at: zod.number(),
  quantity: zod.number().check(zod.positive()),
})

const storedImpressionFields = {
  cart_additions: zod.optional(zod.array(cartAdditionSchema)),
  impression_id: nonEmptyStringSchema,
  product: udpTrackingProductSchema,
  quantity: zod.optional(zod.number()),
}

const recommendationImpressionSchema = zod.object({
  ...storedImpressionFields,
  impression_origin: zod.literal('recommendation'),
  impression_origin_data: recommendationOriginDataSchema,
})

const searchHeaderImpressionSchema = zod.object({
  ...storedImpressionFields,
  impression_origin: zod.enum(['search_header', 'search_header_popular']),
  impression_origin_data: searchHeaderOriginDataSchema,
})

const searchPageImpressionSchema = zod.object({
  ...storedImpressionFields,
  impression_origin: zod.literal('search_page'),
  impression_origin_data: searchPageOriginDataSchema,
})

export const udpTrackingStoredImpressionSchema = zod.union([
  recommendationImpressionSchema,
  searchHeaderImpressionSchema,
  searchPageImpressionSchema,
])

export type UdpTrackingStoredImpression = zod.infer<
  typeof udpTrackingStoredImpressionSchema
>
